<script>
	import { onMount, untrack } from "svelte";
	import { clickOutside } from "@svar-ui/lib-dom";

	/** @type {{ editor: any, onsave: (ignoreFocus?: boolean) => void, onapply: (value: string) => void, oncancel?: (ignoreFocus?: boolean) => void }} */
	let { editor, onsave, onapply, oncancel } = $props();

	let value = $state(untrack(() => editor.value || ""));
	let node = $state();

	onMount(() => {
		node.focus();
		node.setSelectionRange(value.length, value.length);
		resize();
	});

	function updateValue() {
		value = node.value;
		onapply(node.value);
		resize();
	}

	function resize() {
		if (node) {
			node.style.height = "auto";
			node.style.height = `${Math.max(node.scrollHeight, 48)}px`;
		}
	}

	/** @param {KeyboardEvent} e */
	function onKeydown(e) {
		if (e.key === "Enter" && !e.ctrlKey && !e.metaKey) {
			e.stopPropagation();
			return;
		}
		if (e.key === "Enter" && (e.ctrlKey || e.metaKey)) {
			e.preventDefault();
			e.stopPropagation();
			onsave();
			return;
		}
		if (e.key === "Escape") {
			e.preventDefault();
			e.stopPropagation();
			if (oncancel) oncancel(true);
			else onsave(true);
		}
	}
</script>

<textarea
	use:clickOutside={() => onsave(true)}
	class="wx-text wx-textarea"
	rows="2"
	oninput={updateValue}
	onkeydown={onKeydown}
	bind:this={node}
	{value}
></textarea>

<style>
	.wx-textarea {
		width: 100%;
		min-height: 48px;
		height: auto;
		border: none;
		outline: none;
		padding: 6px 8px;
		font: inherit;
		line-height: 1.3;
		background: var(--wx-background);
		color: var(--wx-color-font);
		border: 1px solid var(--wx-color-primary);
		white-space: pre-wrap;
		overflow-wrap: anywhere;
		resize: none;
		box-sizing: border-box;
	}
</style>
